import React from "react";
import { Form, InputGroup, Button } from "react-bootstrap";
import { COLORS } from "../../types/profession.types";

interface ProfessionRowProps {
  profession: any;
  edit: any;
  isSaving: boolean;
  onEdit: (field: string, value: any) => void;
  onSave: () => void;
  onDelete: () => void;
}

export const ProfessionRow: React.FC<ProfessionRowProps> = ({
  profession,
  edit,
  isSaving,
  onEdit,
  onSave,
  onDelete,
}) => {
  const exportPrice = edit.export_price ?? profession.export_price;
  const premiumPrice = edit.premium_price ?? profession.premium_price;
  const maxSlots = edit.max_premium_slots ?? profession.max_premium_slots;
  const isPriority = edit.is_priority ?? profession.is_priority;

  return (
    <tr style={{ backgroundColor: profession.is_priority ? '#fff9e6' : 'transparent' }}>
      {/* Profession */}
      <td className="fw-bold" style={{ minWidth: "200px" }}>
        <div>
          <div>{profession.name}</div>
          {profession.is_priority && (
            <span
              className="badge-custom mt-2"
              style={{ backgroundColor: COLORS.secondary, color: COLORS.white }}
            >
              ⭐ Prioritaire
            </span>
          )}
        </div>
      </td>
      
      {/* Prioritaire */}
      <td className="text-center" style={{ minWidth: "100px" }}>
        <Form.Check
          type="switch"
          id={`priority-${profession.id}`}
          checked={isPriority}
          onChange={(e) => onEdit("is_priority", e.target.checked)}
          disabled={isSaving}
          style={{ transform: "scale(1.2)" }}
        />
      </td>

      {/* Total Utilisateurs */}
      <td className="text-center" style={{ minWidth: "120px" }}>
        {profession.userCount > 0 ? (
          <span className="badge-custom" style={{ backgroundColor: COLORS.primary, color: COLORS.white }}>
            {profession.userCount}
          </span>
        ) : (
          <span className="badge-custom" style={{ backgroundColor: COLORS.white, border: `1px solid ${COLORS.border}`, color: COLORS.textLight }}>
            Aucun
          </span>
        )}
      </td>

      {/* Premium Prix */}
      <td style={{ backgroundColor: "#fff4e6", minWidth: "160px" }}>
        <InputGroup style={{ minWidth: "140px" }}>
          <Form.Control
            type="number"
            min="0"
            step="10"
            value={premiumPrice ?? ""}
            onChange={(e) => onEdit("premium_price", e.target.value ? Number(e.target.value) : null)}
            placeholder="0"
            disabled={isSaving}
            style={{ borderColor: COLORS.border, fontSize: "16px", height: "44px" }}
            inputMode="numeric"
          />
          <InputGroup.Text style={{ height: "44px" }}>€</InputGroup.Text>
        </InputGroup>
      </td>

      {/* Premium Places */}
      <td style={{ backgroundColor: "#fff4e6", minWidth: "120px" }}>
        <div>
          <Form.Control
            type="number"
            min="1"
            max="50"
            step="1"
            value={maxSlots ?? 10}
            onChange={(e) => onEdit("max_premium_slots", e.target.value ? Number(e.target.value) : 10)}
            disabled={isSaving}
            style={{ width: "100%", minWidth: "80px", borderColor: COLORS.border, fontSize: "16px", height: "44px" }}
            inputMode="numeric"
          />
          {profession.premiumCount > 0 && (
            <small className="text-muted d-block mt-1">
              <span style={{ marginRight: '4px' }}>👑</span>
              {profession.premiumCount} occupée(s)
            </small>
          )}
        </div>
      </td>

      {/* Export Prix */}
      <td style={{ backgroundColor: "#e6f7ff", minWidth: "160px" }}>
        <InputGroup style={{ minWidth: "140px" }}>
          <Form.Control
            type="number"
            min="0"
            step="5"
            value={exportPrice ?? ""}
            onChange={(e) => onEdit("export_price", e.target.value ? Number(e.target.value) : null)}
            placeholder="0"
            disabled={isSaving}
            style={{ borderColor: COLORS.border, fontSize: "16px", height: "44px" }}
            inputMode="numeric"
          />
          <InputGroup.Text style={{ height: "44px" }}>€</InputGroup.Text>
        </InputGroup>
      </td>

      {/* Export Statut */}
      <td style={{ backgroundColor: "#e6f7ff", minWidth: "120px", textAlign: "center" }}>
        <span
          className="badge-custom"
          style={{
            backgroundColor: !exportPrice || exportPrice <= 0 ? COLORS.success : COLORS.secondary,
            color: COLORS.white,
          }}
        >
          {!exportPrice || exportPrice <= 0 ? "Gratuit" : "Payant"}
        </span>
      </td>

      {/* Actions */}
      <td className="text-center" style={{ minWidth: "160px" }}>
        <div className="d-flex flex-wrap gap-2 justify-content-center align-items-center">
          <Button
            size="sm"
            variant="link"
            className="text-decoration-none p-0"
            style={{ 
              color: profession.userCount > 0 ? "white" : COLORS.danger,
              fontSize: "14px",
              minHeight: "44px",
              minWidth: "80px",
              padding: "8px 16px",
              borderRadius: "20px",
            }}
            onClick={onDelete}
            disabled={profession.userCount > 0 || isSaving}
            title={profession.userCount > 0 ? "Profession en cours d'utilisation" : ""}
          >
            Supprimer
          </Button>
          <Button
            size="sm"
            onClick={onSave}
            disabled={isSaving}
            style={{
              backgroundColor: isSaving ? COLORS.light : COLORS.primary,
              border: "none",
              color: isSaving ? COLORS.textLight : COLORS.white,
              padding: "8px 16px",
              borderRadius: "20px",
              fontSize: "14px",
              minHeight: "44px",
              minWidth: "80px"
            }}
          >
            {isSaving ? "..." : "Enregistrer"}
          </Button>
        </div>
      </td>
    </tr>
  );
};